<div class="preview-popup">
  @for (file of items?.slice(0, itemsToPreviewCount); track file) {
    <div class="file">
      <div class="file__preview">
        @if (isImageFile(file)) {
          @if (showThumbnail) {
            <img [src]="imagePathProperty ? file[imagePathProperty] : (file | fileUrl)" [alt]="file[nameProperty]" />
          }
        }
        @if (!isImageFile(file)) {
          <i class="far fa-file"></i>
        }
      </div>
      @if (showFilename) {
        <p class="file__name" (click)="fileService.downloadFile(file)">
          {{ file[nameProperty] || file.filename }}
        </p>
      }
      @if (deletable) {
        <i
          class="far fa-times file__remove"
          [title]="'button.delete' | translate"
          (click)="handleRemoveIconClick($event, file)">
        </i>
      }
    </div>
  }

  @if (!showLoader && items?.length > itemsToPreviewCount) {
    <div class="d-flex">
      <span class="dots">...</span>
      @if (!showLoader) {
        <cap-button (click)="showPopup = true" styleClass="files-count" [label]="items?.length - itemsToPreviewCount">
        </cap-button>
      }
    </div>
  }

  @if (showLoader) {
    <i class="fas fa-spinner-third"></i>
  }
</div>

<p-dialog
  [header]="('dental.order.tooth_cross.uploaded_pictures.label' | translate) + '(' + items?.length + ')'"
  [(visible)]="showPopup"
  [baseZIndex]="10000"
  [modal]="true"
  [style]="{ width: '100%', maxWidth: '709px' }">
  <div class="files-list" #fileList [ngClass]="{ 'pe-3': fileList?.scrollHeight > fileList?.clientHeight }">
    @for (file of items; track file) {
      <div class="file">
        <div class="file__preview">
          @if (isImageFile(file)) {
            @if (showThumbnail) {
              <img [src]="imagePathProperty ? file[imagePathProperty] : (file | fileUrl)" [alt]="file[nameProperty]" />
            }
          }
          @if (!isImageFile(file)) {
            <i class="far fa-file"></i>
          }
        </div>
        @if (showFilename) {
          <p class="file__name" (click)="fileService.downloadFile(file)">
            {{ file[nameProperty] || file.filename }}
          </p>
        }
        @if (deletable) {
          <i
            class="fas fa-trash-alt file__remove"
            [title]="'button.delete' | translate"
            (click)="handleRemoveIconClick($event, file)">
          </i>
        }
      </div>
    }
  </div>

  <div class="text-end mt-4">
    <cap-button [label]="'button.close' | translate" styleClass="primary" (click)="showPopup = false"> </cap-button>
  </div>
</p-dialog>
